import React, { useState, useEffect } from "react";
import Modal from "react-modal";
import { useDispatch,useSelector } from "react-redux";

// store
import  {clearFilter,setLoading}  from  "../../configureStore"; 
// helpers
import isObjectEmpty from "../../helper/emptyObj";
// Components
import PillsList from "./pillsList";
Modal.setAppElement("#root");
const PillsModal = (props) => {
  const searchData = useSelector((state) => state.searchData);
  const global = useSelector((state) => state.global);
  const dispatch = useDispatch();
	const [modalIsOpen, setIsOpen] = useState(false);
	useEffect(() => {
		if (props.toggleModal) {
			openModal();
		}
	}, [props.toggleModal]);

	useEffect(() => {
		if (
			isObjectEmpty(searchData.filters.activity) &&
			isObjectEmpty(searchData.filters.amenity) &&
			isObjectEmpty(searchData.filters.discount) &&
			modalIsOpen
		) {
			closeModal();
		}
	}, [searchData]);

	const openModal = () => {
		setIsOpen(true);
		props.callback();
	};

	const closeModal = () => {
		setIsOpen(false);
	};
	const clearFilters = async()=>{
		await dispatch(clearFilter());
		closeModal();
		dispatch(setLoading(true));
	}
	return (
		<div>
			<Modal
				portalClassName={"modal-app modal-app--dynamic modal-app--pills"}
				overlayClassName={"modal-app__overlay"}
				isOpen={modalIsOpen}
				onRequestClose={closeModal}
				className="modal-app__wrapper"
				contentLabel="pills modal">
				<div className="modal-app__header">
					<h2 className="modal-app__title">
						{global.localization.allChosenFilter}
					</h2>
					<button
						className="modal-app__close"
						aria-label="close"
						onClick={closeModal}>
						<div className="icon">
							<img
								src="/assets/images/close.svg"
								alt=""
							/>
						</div>
					</button>
				</div>
				<div className="modal-app__cont">
					<PillsList />
				</div>
				<div className="modal-app__footer">
					<div className="button-row button-row--center">
						<div className="button-row__list">
							<button
								type="button"
								className="button-link"
								onClick={clearFilters}>
								{global.localization.clearFilters}
							</button>
						</div>
					</div>
				</div>
			</Modal>
		</div>
	);
};

export default PillsModal;
